export const border = {
  borderRadius: {
    sm: '3px',
    xl: '16px',
  },
};
